export default __webpack_public_path__ + "static/media/post.45dd309f.png";